import { getNewsletters,getNewsletter, saveNewsletterTargets } from '../../../shared/data-services/newsletter-service';
import { getCampaigns,getCampaignStates } from '../../../shared/data-services/campaign-service';
import { getCustomers } from '../../../shared/data-services/consumer-service';
import { getNewsletterTypes } from '../../../shared/data-services/newslettertype-service';
import { saveCampaignTargets, getCampaignContentTypes, getDataSelectedCampaign, getReportState} from '../../../shared/data-services/campaign-service';
import { getEmployeePositions } from '../../../shared/data-services/employee-position-service';
import { getAirports } from '../../../shared/data-services/airport-service';
import { getAssessments, getAssessmentReportByNewsletterId , getAssessmentReportDetailByNewsletterId } from '../../../shared/data-services/assessment-service';
import { getNewsLetterContentTypes } from '../../../shared/data-services/newsletter-content-type-service';
import { getEmployeesWithProfiles} from '../../../shared/data-services/management-employee-service';
import { getAllDataCompanies} from '../../../shared/data-services/company-service';


export async function getAllCampaigns (EmployeeId, companyId){
  const data = await getCampaigns(EmployeeId, companyId);
  return data || [ ];
};

export async function getAllNewsletters (EmployeeId, companyId){
  const data = await getNewsletters(EmployeeId, companyId);
  return data || [ ];
};

export async function getSelectedNewsletter (id){
  const data = await getNewsletter(id);
  return data;
};

export async function getResportStateData (id){
  const data = await getReportState(id);
  return data || [ ];
};

export async function saveCampaignTarget ( 
  {
    Id,
    startDate,
    endDate,
    CampaignStateId,
    Name,
    CustomerId,
    SelectedEmployeePositions,
    SelectedAirports,
    newListContentNewsletter,
    ContentActivity,
    SelectedPersons,
    CompanyId,
    employeeIdSession
  }){
  const parameters = {
    id: Id, 
    name: Name, 
    startDate: startDate, 
    endDate: endDate,
    customerId: CustomerId, 
    campaignStateId: CampaignStateId, 
    companyId: CompanyId, 
    airports: SelectedAirports,
    employeePositions: SelectedEmployeePositions,
    personCharge: SelectedPersons,
    newsletter: newListContentNewsletter,
    activity: ContentActivity,
    employee: employeeIdSession
  };

  const data = await saveCampaignTargets(parameters);
  return data;
};

export async function getAllCampaignStates (){
  
  const data = await getCampaignStates();
  return data;
};

export async function getAllCustomers (companyId){
  
  const data = await getCustomers(companyId);
  return data;
};

export async function getAllNewsletterTypes (companyId){
  
  const data = await getNewsletterTypes(companyId);
  return data;
};

export async function getAllEmployeePositions (companyId){
  
  const data = await getEmployeePositions(companyId);
  return data;
};

export async function getAllAirports (companyId){
  
  const data = await getAirports(companyId);
  return data;
};


export async function saveAllNewsletterTargets (params){
  const data = await saveNewsletterTargets(params);
  return data;
};

export async function getListAssessment (companyId){
  const data = await getAssessments(companyId);
  return data || [ ];
};



export async function getAllCampaignContentTypes (){
  
  const data = await getCampaignContentTypes();
  return data;
};

export async function getAssessmentReportByNewsletterIdData (id){
  const data = await getAssessmentReportByNewsletterId(id);
  return data || [ ];
};

export async function getAssessmentReportDetailByNewsletterIdData (id){
  const data = await getAssessmentReportDetailByNewsletterId(id);
  return data || [ ];
};

export async function getAllNewsLetterContentTypes (){
  const data = await getNewsLetterContentTypes();
  return data;
};

export async function getEmployees (companyId){
  const data = await getEmployeesWithProfiles(companyId);
  return data || [ ];
};

export async function getSelectedCampaign (Id){
  const data = await getDataSelectedCampaign(Id);
  return data || [ ];
};

export async function getAllCompanies (Id){
  const data = await getAllDataCompanies(Id);
  return data || [ ];
};

